import { promiseTimeout } from '@vueuse/core'
import { DIALOG_MESSAGE } from '~/core/constants'
import useLocaleStore from '~/stores/useLocaleStore'
import useMainDialogStore from '~/stores/useMainDialogStore'
import useTownModalStore from '~/stores/useTownModalStore'
import useProfileStore from '~/stores/useProfileStore'
import { createConfirmTownPopup } from '~/features/Appointments/functions/createConfirmTownPopup'

export const useTownConfirm = () => {
  const profileStore = useProfileStore()

  const $dialog = useMainDialogStore()
  const locale = useLocaleStore()
  const townModalStore = useTownModalStore()
  const ONLINE_TOWN_KEY = 'online'

  function openUrlWithTownConfirm(townKey = '', category = '', showDialogBeforeRedirect = false) {
    const town = profileStore.town

    const redirect = (town = townKey || '') => {
      town = townKey !== ONLINE_TOWN_KEY ? town : ONLINE_TOWN_KEY

      if (!showDialogBeforeRedirect) {
        window.location.assign(`${locale.pdUrl}/${town}/${category}`)

        return
      }

      $dialog.open({
        ...getRedirectDialogMessage(town),
        confirmHandler: () => window.location.assign(`${locale.pdUrl}/${town}/${category}`),
      })
    }

    if (!profileStore.townConfirmed) {
      $dialog.open({
        ...createConfirmTownPopup({
          town,
          selectTownHandler: () => townModalStore.open({
            afterTownSelectHandler: async (selectedTown: string) => {
              townModalStore.close()
              // NOTE: Ждём завершения анимации закрытия попапа. Иначе анимация непосредственно перед редиректом может лагать
              await promiseTimeout(500)
              redirect(selectedTown)
            },
          }),
          redirectHandler: async () => {
            townModalStore.close()
            // TODO: после перехода на Pinia перенести изменение статуса туда, в запрос на подтверждение
            profileStore.townConfirmed = true
            // NOTE: Ждём завершения анимации закрытия попапа. Иначе анимация непосредственно перед редиректом может лагать
            await promiseTimeout(500)
            redirect()
          },
        }),
      })

      return
    }

    redirect()
  }

  function getRedirectDialogMessage(town: string) {
    const base = {
      ...(locale.isCis
        ? DIALOG_MESSAGE.REDIRECT_TO_YDOC
        : DIALOG_MESSAGE.REDIRECT_TO_PD),
    }

    if (locale.isRu && town === ONLINE_TOWN_KEY) {
      base.title = 'Вы переходите на ПроДокторов для записи на онлайн-консультацию'
    }

    return base
  }

  return {
    openUrlWithTownConfirm,
  }
}
